export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-v1-1200-21edeb0158f320f17d7c958d74139c84.png";